import styled from 'styled-components';

export const StyledCategorySubTableV2 = styled.div`
  position: relative;
  width: 50%;

  .MuiTableCell-root {
    padding: 0;
    line-height: unset;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    tbody {
      td {
        height: 40px;
        background: #fff;
        text-align: center;
        cursor: pointer;

        &:hover {
          color: #b38b3a;
        }
      }
    }

    tr {
      th {
        height: 40px;
        border-top: 0.5px solid #dadada;
        border-bottom: 0.5px solid #dadada;
        background: #f8f8f8;
        text-align: center;

        &.addBtn {
          width: 69px;

          .MuiButtonBase-root {
            height: 33px;
          }
        }
      }
    }
  }

  .total {
    position: absolute;
    top: -30px;
    right: 0;
  }

  .buttonWrap {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 6px;
      width: 32px;
      height: 32px;
      border-radius: 4px;
      border: 0.5px solid #dadada;
      background: #f8f8f8;
    }
  }
`;
